import * as React from 'react';

import MessageModalGraphicSvg from './message-modal-graphic.svg';

import styles from './message-modal-graphic.module.css';

export class MessageModalGraphic extends React.PureComponent<Record<any, any>> {
    render() {
        return (
            <div className={styles.container}>
                <MessageModalGraphicSvg />
            </div>
        );
    }
}
